import { useContext } from 'react';
import { EsigningContext } from './EsigningContext';
export const useEsigning = () => {
    const context = useContext(EsigningContext);
    if (!context) {
        throw new Error('useEsigning hook used outside <EsigningProvider />');
    }
    return context;
};
